import { useEffect } from "react";
import { useStore } from "stores/connect";
import ForwarderInputStatesStore, { ForwarderInputStatesActions } from "./stores/ForwarderInputStatesStore";
const FAILED_STATES = ["FAILED", "FAILING", "INVALID_CONFIGURATION"];
const useForwarderInputsBadgeCondition = () => {
  var _a;
  const { forwarderInputStates: states } = useStore(ForwarderInputStatesStore);
  useEffect(() => {
    ForwarderInputStatesActions.register();
    return () => ForwarderInputStatesActions.unregister();
  }, []);
  const hasIssues = (_a = states == null ? void 0 : states.some((state) => FAILED_STATES.includes(state.state))) != null ? _a : false;
  return { hasIssues, title: "Some forwarder inputs are in failed state." };
};
export default useForwarderInputsBadgeCondition;
